import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'
import moment from 'moment'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  authenticate: {
    url: '/auth/login',
    // params: {
    //   include: [
    //     'customer',
    //     'customer.addresses',
    //     'customer.priceDiscountLevel'
    //   ]
    // }
  },
  refreshAuthentication: {
    url: '/auth/refresh',
    // params: {
    //   include: [
    //     'customer',
    //     'customer.addresses',
    //     'customer.priceDiscountLevel'
    //   ]
    // }
  },
  sendPasswordResetLinkEmail: {
    url: '/auth/forgot',
  },
  resetPassword: {
    url: '/auth/reset',
  }

}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  token: '',
  expires: ''
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  token: state => state.token,
  expires: state => state.expires
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_CREATE_AUTH = 'REQUEST_CREATE_AUTH'
const RECEIVE_CREATE_AUTH = 'RECEIVE_CREATE_AUTH'

const REQUEST_REFRESH_AUTH = 'REQUEST_REFRESH_AUTH'

const REQUEST_DELETE_AUTH = 'REQUEST_DELETE_AUTH'
const RECEIVE_DELETE_AUTH = 'RECEIVE_DELETE_AUTH'

const REQUEST_SEND_RESET_LINK_EMAIL = 'REQUEST_SEND_RESET_LINK_EMAIL'
const RECEIVE_SEND_RESET_LINK_EMAIL = 'RECEIVE_SEND_RESET_LINK_EMAIL'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async authenticate ({ commit, dispatch }, { data, includes = undefined }) {
    dispatch('wait/start', 'authenticating', { root: true })
    commit(REQUEST_CREATE_AUTH)
    const config = merge({}, endpointConfig.authenticate, { params: { include: includes } })
    return axios.post(`${endpointConfig.authenticate.url}`, data, config)
      .then((response) => {
        dispatch('receiveAuth', [ response.data, 'CREATE' ])
        if (response.data.data.user) {
          commit(`RECEIVE_GET_USER`, response.data.data.user, { root: true })
        }
        if (response.data.data.customer) {
          commit(`RECEIVE_GET_CUSTOMER`, response.data.data.customer, { root: true })
        }
        dispatch('wait/end', 'authenticating', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'authenticating', { root: true })
        return Promise.reject(error)
      })
  },
  async refreshAuthentication ({ commit, dispatch }, includes = undefined) {
    dispatch('wait/start', 'refreshing authentication', { root: true })
    commit(REQUEST_REFRESH_AUTH)
    const config = merge({}, endpointConfig.refreshAuthentication, { params: { include: includes } })
    return axios.post(`${endpointConfig.refreshAuthentication.url}`, {}, config)
      .then((response) => {
        console.log(response)
        dispatch('receiveAuth', [ response.data, 'CREATE' ])
        if (response.data.data.user) {
          commit(`RECEIVE_GET_USER`, response.data.data.user, { root: true })
        }
        if (response.data.data.customer) {
          commit(`RECEIVE_GET_CUSTOMER`, response.data.data.customer, { root: true })
        }
        dispatch('wait/end', 'refreshing authentication', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'refreshing authentication', { root: true })
        return Promise.reject(error)
      })
  },
  deauthenticate ({ commit }) {
    commit(REQUEST_DELETE_AUTH)
    commit(RECEIVE_DELETE_AUTH)
    return Promise.resolve(true)
  },
  receiveAuth ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_AUTH`, extract(json))
    return json.data
  },
  async sendPasswordResetLinkEmail ({ commit, dispatch }, data) {
    dispatch('wait/start', 'sending password reset link email', { root: true })
    commit(REQUEST_SEND_RESET_LINK_EMAIL)
    return axios.post(`${endpointConfig.sendPasswordResetLinkEmail.url}`, data)
      .then((response) => {
        console.log(response)
        commit(RECEIVE_SEND_RESET_LINK_EMAIL)
        dispatch('wait/end', 'sending password reset link email', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        commit(RECEIVE_SEND_RESET_LINK_EMAIL)
        dispatch('wait/end', 'sending password reset link email', { root: true })
        return Promise.reject(error)
      })
  },
  async resetPassword({ commit, dispatch }, data) {
    dispatch('wait/start', 'resetting password', { root: true })
    commit(REQUEST_SEND_RESET_LINK_EMAIL)
    return axios.post(`${endpointConfig.resetPassword.url}`, data)
      .then((response) => {
        console.log(response)
        commit(RECEIVE_SEND_RESET_LINK_EMAIL)
        dispatch('wait/end', 'resetting password', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        commit(RECEIVE_SEND_RESET_LINK_EMAIL)
        dispatch('wait/end', 'resetting password', { root: true })
        return Promise.reject(error)
      })
  }

}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_CREATE_AUTH] () {
  },
  [RECEIVE_CREATE_AUTH] (state, json) {
    state.token = json.token
    state.expires = moment().add(json.expires_in, 'seconds').format()
  },
  [REQUEST_REFRESH_AUTH] () {
  },
  [REQUEST_DELETE_AUTH] () {
  },
  [RECEIVE_DELETE_AUTH] (state) {
    state.token = ''
    state.expires = ''
  },
  [REQUEST_SEND_RESET_LINK_EMAIL]() {
  },
  [RECEIVE_SEND_RESET_LINK_EMAIL]() {
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
